import APP_CONSTANT from "@src/CommonComponents/ChangeProviderComponent/constant";
import { GET_GEO_SEGMENTATION_SEARCH_LIST_FAILURE, GET_GEO_SEGMENTATION_SEARCH_LIST_SUCCESS, GET_TAX_ID_SEARCH_LIST_FAILURE, GET_TAX_ID_SEARCH_LIST_SUCCESS, GET_TOP_SEARCHED_LIST_SUCCESS, PROVIDER_SEARCH_FAILURE, PROVIDER_SEARCH_LOADING, PROVIDER_SEARCH_SUCCESS, SAVE_GEO_SEARCH_DETAILS_SUCCESS, SAVE_SEARCH_DETAILS_SUCCESS, SAVE_TINS_GROUP_SUCCESS, UPDATE_NAVIGATION_LINK, USER_DETAILS_FETCHED } from "@src/middleware/actions/actionTypes";

interface ProviderSearchState {
  topSearchedList: any;
  userDetail: any;
  options: any;
  navigateTo: string | undefined | null;
  contractId: string | null;
  isSearchLoading: boolean;
  isErrorSearch: boolean;
  isProviderError: boolean;
  isTaxIdError: boolean;
  isGeoSegmentError: boolean;
}

const initialState: ProviderSearchState = {
  topSearchedList: { HEALTH_SYSTEM: [], TAX_ID: [], CONTRACT_ID: [], GEO_SEGMENTATION: [], SAVE_TAXID: [] },
  userDetail: {},
  options: [],
  navigateTo: null,
  contractId: null,
  isSearchLoading: false,
  isErrorSearch: false,
  isProviderError: false,
  isTaxIdError: false,
  isGeoSegmentError: false,
};

const generateOptions = (items, mapFn, extraOptions) => {

  const mappedOptions = (items ?? []).map(mapFn);
  const isEnableBtn = mappedOptions?.some((item) => item?.isChecked);
  const options = [
    {
      value: extraOptions.firstOption,
      title: extraOptions.firstOption,
      isDisabled: true,
      isExtraOption: true,
      isEnabled: isEnableBtn,
    },
    ...mappedOptions,
    {
      value: extraOptions.lastSecondOption,
      title: extraOptions.lastSecondOption,
      isDisabled: true,
      isExtraOption: true,
      isEnabled: false,
    },
    {
      value: extraOptions.lastOption,
      title: extraOptions.lastOption,
      isDisabled: true,
      isExtraOption: true,
      isEnabled: isEnableBtn,
    },
  ];
  return options;
};

const providerSearchReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): ProviderSearchState => {
  switch (action.type) {
    case USER_DETAILS_FETCHED: {
      const { userDetail } = action.payload;
      return {
        ...state,
        userDetail,
      };
    }
    case GET_TOP_SEARCHED_LIST_SUCCESS: {
      const { TAB_KEYS } = APP_CONSTANT;
      const responseData = action.payload.response ?? [];
      const userSavedTinGroups = action.payload.userSavedTinGroups ?? [];
      const _topSearchedList: any = {};

      _topSearchedList[TAB_KEYS.HEALTH_SYSTEM] =
        responseData[0]?.ProviderDetails?.map((item) => ({
          ...item,
          value: item?.ProviderSysKey,
          label: item?.ProviderSystem,
        })) ?? [];
      _topSearchedList[TAB_KEYS.TAX_ID] =
        responseData[0]?.TinDetails?.map((item) => ({
          ...item,
          value: item?.Tin,
          label: item?.TinName,
        })) ?? [];
      _topSearchedList[TAB_KEYS.CONTRACT_ID] =
        responseData[0]?.ContractSearchRollUpDetails?.slice(0, 5)?.map((item) => ({
          ...item,
          value: item?.SearchedContractId,
          label: item?.SearchedContractId,
          totalTaxIds: item?.TinCount ?? 0,
        })) ?? [];
      _topSearchedList[TAB_KEYS.GEO_SEGMENTATION] =
        responseData[0]?.GeoSearchRollUpDetails?.map((item) => ({
          ...item,
          value: item?.GeoSearchString,
          label: item?.GeoSearchString,
        })) ?? [];

      _topSearchedList[TAB_KEYS.SAVE_TAXID] = userSavedTinGroups.map((item) => ({ ...item, value: item?.UserSelectedGroupId, label: item?.GroupName })) ?? [];

      return {
        ...state,
        topSearchedList: _topSearchedList,
      };
    }
    case PROVIDER_SEARCH_LOADING: {
      return {
        ...state,
        isSearchLoading: action.payload,
      };
    }
    case PROVIDER_SEARCH_SUCCESS: {
      const { EXTRA_OPTION_TYPE } = APP_CONSTANT;
      const options = generateOptions(
        action.payload,
        (item) => ({
          ...item,
          value: item.ProviderSysKey,
          label: item.ProviderSystem,
        }),
        EXTRA_OPTION_TYPE
      );
      return {
        ...state,
        options,
        contractId: action.payload?.[0]?.ContractId ?? null,
        isProviderError: false,
        isSearchLoading: false,
      };
    }

    case GET_TAX_ID_SEARCH_LIST_SUCCESS: {
      const { EXTRA_OPTION_TYPE } = APP_CONSTANT;
      const options = generateOptions(
        action.payload,
        (item) => ({
          ...item,
          value: item?.Tin ?? item?.ContractId ?? item?.value,
          label: item?.TinName ?? item?.label ?? (item?.TinCount !== undefined ? `TIN Count: ${item.TinCount}` : undefined),
          isDisabled: true,
          isChecked: false,
        }),
        EXTRA_OPTION_TYPE
      );

      return {
        ...state,
        options,
        isTaxIdError: false,
        isSearchLoading: false,
      };
    }
    case GET_GEO_SEGMENTATION_SEARCH_LIST_SUCCESS: {
      const { EXTRA_OPTION_TYPE, GEO_SEGMENTATION_SEARCH } = APP_CONSTANT;
      const _options = Object.entries(action.payload ?? []).reduce(
        (prev, [key, value = []]: [string, any[]]) => {
          const label: string = GEO_SEGMENTATION_SEARCH[key];
          const values: any[] = value.map((item: any) => ({
            value: item,
            label,
            isDisabled: true,
            isChecked: false,
            isHidden: false,
          }));
          return [...prev, ...values];
        },
        []
      );

      const options = _options.length ? generateOptions(_options, (item) => item, EXTRA_OPTION_TYPE) : [];
      return {
        ...state,
        options,
        isGeoSegmentError: false,
        isSearchLoading: false,
      };
    }
    case SAVE_SEARCH_DETAILS_SUCCESS: {

      const { OVERVIEW_PAGE_URL } = APP_CONSTANT;
      const isPSMSJourney = sessionStorage.getItem('isPSMSReportCardClicked') === 'true';
      return {
        ...state,
        navigateTo: isPSMSJourney ? "/PSMS" : window.location.pathname,
      };
    }
    case SAVE_TINS_GROUP_SUCCESS: {
      const { OVERVIEW_PAGE_URL } = APP_CONSTANT;
      const isPSMSJourney = sessionStorage.getItem('isPSMSReportCardClicked') === 'true';
      return {
        ...state,
        navigateTo: isPSMSJourney ? "/PSMS" : OVERVIEW_PAGE_URL,
      };
    }
    case SAVE_GEO_SEARCH_DETAILS_SUCCESS: {
      const { OVERVIEW_PAGE_URL } = APP_CONSTANT;
      return {
        ...state,
        navigateTo: action.payload.navigateTo ?? OVERVIEW_PAGE_URL,
      };
    }
    case UPDATE_NAVIGATION_LINK: {
      return {
        ...state,
        navigateTo: action.payload,
      };
    }
    case PROVIDER_SEARCH_FAILURE: {
      return {
        ...state,
        isProviderError: true,
        options: [],
        contractId: null,
        isSearchLoading: false,
      };
    }
    case GET_TAX_ID_SEARCH_LIST_FAILURE: {
      return {
        ...state,
        isTaxIdError: true,
        isSearchLoading: false,
      };
    }
    case GET_GEO_SEGMENTATION_SEARCH_LIST_FAILURE: {
      return {
        ...state,
        isGeoSegmentError: true,
        isSearchLoading: false,
      };
    }
    default:
      return state;
  }
};

export default providerSearchReducer;
